import request from '@/utils/request'

// 获取验证码
export function getSmsCode(query){
  return request({
    url: '/api/agent/getSmsCode',
    method: 'post',
    data: query
  })
}

// id换取邀请码
export function agentRegisterCode(query){
  return request({
    url: '/api/agent/register',
    method: 'get',
    params: query
  })
}

// 注册
export function agentRegisterUser(query){
  return request({
    url: 'api/agent/register',
    method: 'post',
    data: query
  })
}

// 协议内容
export function protocolType(query){
  return request({
    url: 'api/protocol/' + query,
    method: 'get'
  })
}

// 获取版本信息
export function getLatestVersion(query){
  return request({
    url: '/api/version/getLatestVersion',
    method: 'post',
    data: query
  })
}